'use client';

import { createContext, useContext, useEffect, useState } from 'react';
import { createClient } from '@/lib/supabase/client';

export interface CompanyOption {
  id: string;
  name: string;
}

interface CompanyFilterContextType {
  selectedCompanyId: string;
  setSelectedCompanyId: (id: string) => void;
  companies: CompanyOption[];
  loadingCompanies: boolean;
}

const CompanyFilterContext = createContext<CompanyFilterContextType>({
  selectedCompanyId: 'all',
  setSelectedCompanyId: () => {},
  companies: [],
  loadingCompanies: true,
});

export const useCompanyFilter = () => useContext(CompanyFilterContext);

export const CompanyFilterProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedCompanyId, setSelectedCompanyId] = useState<string>('all');
  const [companies, setCompanies] = useState<CompanyOption[]>([]);
  const [loadingCompanies, setLoadingCompanies] = useState(true);

  const supabase = createClient();

  useEffect(() => {
    const fetchCompanies = async () => {
      const { data, error } = await supabase
        .from('companies')
        .select('id, name')
        .eq('status', 'active')
        .order('name');
      if (!error && data) {
        setCompanies(data as CompanyOption[]);
      }
      setLoadingCompanies(false);
    };
    fetchCompanies();
  }, []);

  return (
    <CompanyFilterContext.Provider value={{ selectedCompanyId, setSelectedCompanyId, companies, loadingCompanies }}>
      {children}
    </CompanyFilterContext.Provider>
  );
};
